export const GET_INVOICES = "/payments/";
export const DOWNLOAD_INVOICE = "/payments/adviser_download/:id/:index/";
